@if (policyNotFound) {
  <app-policy-not-found/>
}
@if (!policyNotFound) {
  <div class="cds-flex cds-flex-col cds-h-full">
    @if (loading) {
      <div
        class="cds-flex cds-flex-col cds-justify-center cds-items-center cds-p-3 md:cds-p-0 cds-gap-2 cds-h-full"
        data-testid="searching-screen">
        <p-progressSpinner/>
        <h3 class="cds-mt-6 cds-text-center">Searching Policy</h3>
        <p class="body-regular cds-text-center">Please wait while the system retrieves the policy</p>
      </div>
    } @else {
      @if (policyData && policyData.policy) {
        <div
          class="cds-flex cds-justify-start md:cds-justify-end cds-items-center cds-py-3 cds-w-full cds-px-5 md:cds-px-[100px] qfa-header"
          data-testid="policy-header">
          <div class="cds-flex cds-gap-2 cds-items-center cds-text-nowrap">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M14.0114 12.9732V1.54173C14.0114 1.28391 13.8024 1.07491 13.5446 1.07491H12.4688V0.466816C12.4688 0.208993 12.2598 0 12.002 0H5.19499C4.486 0 3.88367 0.448342 3.6453 1.07491H2.45703C2.19922 1.07491 1.99023 1.28391 1.99023 1.54173V15.5332C1.99023 15.791 2.19922 16 2.45703 16H13.5446C13.8024 16 14.0114 15.791 14.0114 15.5332V14.1881H13.0778V15.0664H2.92383V2.00855H3.53288V2.6531C3.53288 2.91093 3.74186 3.11992 3.99967 3.11992H10.8066C11.529 3.11992 12.1391 2.65379 12.3676 2.00855H13.0778V12.9732H14.0114ZM11.5352 1.45774C11.5352 1.85945 11.2083 2.18629 10.8066 2.18629H4.46647V1.66218C4.46647 1.26047 4.79329 0.933632 5.19499 0.933632H11.5352V1.45774Z"
                fill="#4B4E53" />
              <path d="M11.0553 5.47027H4.84342V6.40391H11.0553V5.47027Z" fill="#4B4E53" />
              <path d="M11.0553 8.20606H4.84342V9.1397H11.0553V8.20606Z" fill="#4B4E53" />
              <path d="M11.0553 10.867H4.84342V11.8006H11.0553V10.867Z" fill="#4B4E53" />
            </svg>
            <p class="body-regular cds-text-neutral-600 !cds-font-semibold" data-testid="policy-header-number">
              QFA No. {{ policyData.policy.number }}
            </p>
          </div>
        </div>
        <div
          class="cds-flex cds-flex-col md:cds-flex-row cds-overflow-y-auto cds-h-[calc(100vh-190px)] md:cds-h-full md:cds-overflow-y-none">
          <app-progress/>
          <div
            class="cds-flex cds-flex-col cds-overflow-y-none md:cds-overflow-y-auto cds-h-full md:cds-h-[calc(100vh-201px)] cds-w-full">
            <app-alert-banner
              [message]="policyAlertMessage.message ?? ''"
              [showAlertBanner]="openPolicyAlert"
              [alertType]="policyAlertMessage.type ?? alertBannerType.informational"
              (closeTriggered)="closeAlert()"/>
            <app-coverage-tabs/>
          </div>
        </div>
        <div
          class="cds-fixed cds-bottom-0 cds-left-0 cds-pl-5 md:cds-pl-[86px] cds-border-t-2 cds-border-[#6e27c5] cds-flex cds-justify-between cds-items-center cds-z-[995] cds-w-full cds-bg-white">
          <app-total-premium class="cds-w-full"/>
        </div>
      }
    }
  </div>
}
